import 'react';

import styled from '@emotion/styled';

import { ResponsiveBreakPoints } from '~/constants/responsive';
import { colors, fontWeight } from '~/styles/constants';

interface StyledProps {
  hasShadow?: boolean;
  isAlwaysRounded?: boolean;
}

const Card = styled('section')<StyledProps>`
  border: 1px solid ${colors.greyBorder};
  border-radius: ${(props) => (props.isAlwaysRounded ? '6px' : '0px')};
  @media screen and (min-width: ${ResponsiveBreakPoints.Tablet}px) {
    border-radius: 6px;
  }
  padding: 24px;

  ${(props) => (props.hasShadow ? 'box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.15);' : '')}
`;

export default Card;

export const InfoCard = styled(Card)`
  margin-bottom: 17px;
  padding: 18px 21px;
  font-size: 13px;
  color: ${colors.fontColor};
  border: 1px solid #e8e395;
  background-color: #fffced;
  line-height: 18px;
`;

export const InfoCardTitle = styled('h2')`
  color: #e8d576;
  font-size: 13px;
  font-weight: ${fontWeight.medium};
  margin: 0 0 5px 0;
`;

export const GrayInfoCard = styled(Card)`
  background-color: ${colors.gray25};
  border: 1px solid ${colors.gray400};
  border-radius: 3px;
  color: ${colors.gray900};
  padding: 1rem;
`;
